module.exports = __webpack_public_path__ + "img/II-6.6fa5d936.svg";